import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs.tsx";
import ReasoningPane from "./ReasoningPane.tsx";
import SourcesPane from "./SourcesPane.tsx";

interface Source {
  title: string;
  url: string;
}

interface KpiDriverTabsProps {
  reasoning: string;
  sources?: Source[];
}

export default function KpiDriverTabs({
  reasoning,
  sources,
}: KpiDriverTabsProps) {
  const hasSources = sources && sources.length > 0;

  return (
    <Tabs defaultValue="reasoning" className="w-full">
      <div className="px-4 pt-4">
        <TabsList>
          <TabsTrigger value="reasoning">Reasoning</TabsTrigger>
          {hasSources && <TabsTrigger value="sources">Sources</TabsTrigger>}
        </TabsList>
      </div>

      <TabsContent value="reasoning" className="p-4 mt-0">
        <ReasoningPane reasoning={reasoning} />
      </TabsContent>

      {hasSources && (
        <TabsContent value="sources" className="p-4 mt-0">
          <SourcesPane sources={sources} />
        </TabsContent>
      )}
    </Tabs>
  );
}
